import { render, staticRenderFns } from "./ICMArrowButton.vue?vue&type=template&id=559a655d&scoped=true&"
import script from "./ICMArrowButton.vue?vue&type=script&lang=ts&"
export * from "./ICMArrowButton.vue?vue&type=script&lang=ts&"
import style0 from "./ICMArrowButton.vue?vue&type=style&index=0&id=559a655d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559a655d",
  null
  
)

export default component.exports